module.exports = __webpack_public_path__ + "img/Map.7f0bbf5b.png";